export async function getRequest(params: any) {
  const queryParams = {
    lang: params.lang ?? "",
    path: JSON.stringify(params.path) ?? "",
    skipCache: params.skipCache ?? false,
  };
  const query = new URLSearchParams(queryParams);
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_WEB_URL}/api/request?${query.toString()}`,
    { headers: { "x-oc-image-dimension": "900x600" } },
  );
  return await response.json();
}

export async function postRequest(params: any) {
  const method = params.method ?? "POST";
  const headers = params.headers ?? {};
  const body = params.body ?? {};
  let data;
  const lang = params.lang ?? "";
  const path = params.path ?? "/";
  const requestBody = {
    lang,
    method,
    path,
  };
  if (params.formData && params.formData instanceof FormData) {
    data = params.formData;
    data.append("jsonStuff", JSON.stringify(requestBody));
  } else {
    data = JSON.stringify({
      ...requestBody,
      data: body,
    });
  }

  const response = await fetch(`/api/request`, {
    method: "POST",
    headers,
    body: data,
  });
  return await response.json();
}
